<template>
  <div :class="`dynamic-text_${widget.id}`" v-tooltip-link-fix v-quill-editor-bubble-theme-fix>
    <div v-html="`<style>${options.style.css}</style>`"></div>
    <QuillEditor :class="widget.id" :content="options.content" @change="updateContent" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import QuillEditor from '@/shared/components/QuillEditor'
import WidgetMixin from './Mixin.js'
import QuillEditorBubbleThemeFix from '@/shared/directives/quillEditorBubbleThemeFix.js'
import TooltipLinkFix from '@/shared/directives/tooltipLinkFix.js'

export default {
  directives: { TooltipLinkFix, QuillEditorBubbleThemeFix },
  name: 'DynamicTextWidget',
  mixins: [WidgetMixin],
  components: { QuillEditor },
  methods: {
    updateContent(value) {
      const newValue = value.replaceAll('{', '&#123;').replaceAll('}', '&#125;')
      this.updateOptions({ id: this.widget.id, path: 'content', value: newValue })
    },
    ...mapActions('landing', ['updateOptions']),
  },
}
</script>

<style lang="scss" scoped>
[class*='text_'] {
  width: 100%;
}
/deep/ {
  .no-overflow {
    overflow: inherit;
  }
}
</style>
